export type LayoutType = 
  | "standard" 
  | "title-only" 
  | "title-content" 
  | "split" 
  | "image-text"
  | "titleSlide"
  | "contentFull"
  | "contentTwoCol"
  | "contentThreeCol" 
  | "contentFourCol"
  | "contentWithMediaRight"
  | "contentWithMediaLeft"
  | "imageWithCaption"
  | "videoWithCaption"
  | "imageGrid"
  | "table"
  | "chartSingle"
  | "chartDual"
  | "dashboard"
  | "processHorizontal"
  | "processVertical"
  | "timelineHorizontal"
  | "timelineVertical"
  | "contactInfo"

export interface MediaItem {
  path: string;
  type: string;
}

export interface ChartData {
  type: string;
  data: Array<{
    name: string;
    labels: string[];
    values: number[];
  }>;
}

export interface TableData {
  rows: string[][];
  options: {
    columnWidths: number[];
    autoPageRepeat: boolean;
    autoPageSlides: boolean;
    fontFace: string;
    fontSize: number;
    color: string;
    border: {
      type: string;
      pt: number;
      color: string;
    };
    headerRow: boolean;
    headerRowOptions: {
      fontFace: string;
      fontSize: number;
      bold: boolean;
      color: string;
      fill: {
        color: string;
      };
    };
    zebra: boolean;
    zebraColors: string[];
  };
}

export interface Arrow {
  type: string;
  color: string;
}

export interface Milestone {
  color: string;
}

export interface Slide {
  id: string;
  title?: string;
  content?: string;
  layout: LayoutType;
  background?: string;
  images?: string[];
  titleColor?: string;
  textColor?: string;
  
  // For titleSlide layout
  subtitle?: string;
  
  // For multicolumn layouts
  colLeft?: string;
  colRight?: string;
  colMiddle?: string;
  col1?: string;
  col2?: string;
  col3?: string;
  col4?: string;
  
  // For media layouts
  media?: MediaItem;
  image?: MediaItem;
  caption?: string;
  
  // For image grid
  cell_1_1?: MediaItem;
  cell_1_2?: MediaItem;
  cell_1_3?: MediaItem;
  cell_2_1?: MediaItem;
  cell_2_2?: MediaItem;
  cell_2_3?: MediaItem;
  
  // For chart layouts
  chart?: ChartData;
  chartLeft?: ChartData;
  chartRight?: ChartData;
  chart1?: ChartData;
  chart2?: ChartData;
  chart3?: ChartData;
  chart4?: ChartData;
  explanationTitle?: string;
  explanationContent?: string;
  explanationLeft?: string;
  explanationRight?: string;
  titleLeft?: string;
  titleRight?: string;
  
  // For table layout
  table?: TableData;
  
  // For process layouts
  step1Box?: string;
  step2Box?: string;
  step3Box?: string;
  step4Box?: string;
  step1Text?: string;
  step2Text?: string;
  step3Text?: string;
  step4Text?: string;
  arrow1?: Arrow;
  arrow2?: Arrow;
  arrow3?: Arrow;
  
  // For timeline layouts
  timelineBar?: { color: string };
  milestone1?: Milestone;
  milestone2?: Milestone;
  milestone3?: Milestone;
  milestone4?: Milestone;
  milestone1Upper?: string;
  milestone2Upper?: string;
  milestone3Upper?: string;
  milestone4Upper?: string;
  milestone1Lower?: string;
  milestone2Lower?: string;
  milestone3Lower?: string;
  milestone4Lower?: string;
  milestone1Date?: string;
  milestone2Date?: string;
  milestone3Date?: string;
  milestone4Date?: string;
  milestone1Text?: string;
  milestone2Text?: string;
  milestone3Text?: string;
  milestone4Text?: string;
  
  // For contact info layout
  thankYouText?: string;
  contactInfo?: string;
}

export interface Theme {
  slideBackground: string;
  titleColor: string;
  textColor: string;
  accentColor: string;
  fontFamily: string;
  transition: string;
  presentationName?: string;
  showSlideNumbers: boolean;
  showProgressBar: boolean;
  autoPlay: boolean;
  slideDuration?: number;
  subject?: string;
  author?: string;
}

export const defaultTheme: Theme = {
  slideBackground: "#ffffff", 
  titleColor: "#1a1a1a",     
  textColor: "#333333",      
  accentColor: "#3b82f6",
  fontFamily: "'Inter', sans-serif",
  transition: "fade",
  presentationName: "My Presentation",
  showSlideNumbers: true,
  showProgressBar: true,
  autoPlay: false,
  slideDuration: 5,
  subject: "",
  author: "Edunova",
}

export const defaultSlides: Slide[] = [
  {
    id: "slide-1",
    title: "Welcome to Your Presentation",
    content: "Click to edit this text and start creating your presentation",
    layout: "title-only",
    background: "#ffffff",
    titleColor: "#000000",
    textColor: "#000000",
  },
  {
    id: "slide-2",
    title: "Key Points",
    content: "• First important point\n• Second important point\n• Third important point",
    layout: "title-content",
    background: "#ffffff",
    titleColor: "#000000",
    textColor: "#000000",
  },
  {
    id: "slide-3",
    title: "Split Layout Example",
    content: "This is an example of a split layout slide where you can have content on both sides.",
    layout: "split",
    background: "#ffffff",
    titleColor: "#000000",
    textColor: "#000000",
  },
]
